module.exports = __webpack_public_path__ + "img/reflect-feet.35149c1.jpg";